import { render } from "./BodyPrestige.vue?vue&type=template&id=1bf20df0"
import script from "./BodyPrestige.vue?vue&type=script&lang=js"
export * from "./BodyPrestige.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/reports/windowOverlay/reportInfo/BodyPrestige.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bf20df0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bf20df0', __exports__)) {
    api.reload('1bf20df0', __exports__)
  }
  
  module.hot.accept("./BodyPrestige.vue?vue&type=template&id=1bf20df0", () => {
    api.rerender('1bf20df0', render)
  })

}


export default __exports__